import { Action } from '../../../common/actions/core/action';

export class OpenStudentQuotaAction implements Action {
  constructor() {}
}



// WEBPACK FOOTER //
// src/app/components/student/quota-exceeded/quota-exceeded.action.ts